/**
 * Workflow ACTION node catalog — designer, engine emit, API listener parity.
 * Update listenerStatus when apps/api registers automation.action.* handlers.
 */

/** @typedef {'wired'|'pending'|'notify-node-only'} ListenerStatus */

/**
 * @type {ReadonlyArray<{
 *   actionType: string,
 *   eventName: string,
 *   designerForm: boolean,
 *   listenerStatus: ListenerStatus,
 *   worker?: string,
 * }>}
 */
export const WORKFLOW_AUTOMATION_ACTION_REGISTRY = [
    { actionType: 'notify', eventName: 'automation.action.notify', designerForm: true, listenerStatus: 'wired' },
    { actionType: 'render-report', eventName: 'automation.action.render-report', designerForm: true, listenerStatus: 'wired', worker: 'heavy' },
    { actionType: 'survey-dispatch', eventName: 'automation.action.survey-dispatch', designerForm: true, listenerStatus: 'wired' },
    { actionType: 'http-webhook', eventName: 'automation.action.http-webhook', designerForm: true, listenerStatus: 'wired' },
    { actionType: 'generate-document', eventName: 'automation.action.generate-document', designerForm: true, listenerStatus: 'wired', worker: 'heavy' },
    { actionType: 'wait', eventName: 'automation.action.wait', designerForm: true, listenerStatus: 'wired' },
    { actionType: 'create-entity-record', eventName: 'automation.action.create-entity-record', designerForm: true, listenerStatus: 'wired' },
    { actionType: 'create-ticket', eventName: 'automation.action.create-ticket', designerForm: true, listenerStatus: 'wired' },
    { actionType: 'update-entity-field', eventName: 'automation.action.update-entity-field', designerForm: true, listenerStatus: 'wired' },
    { actionType: 'start-workflow', eventName: 'automation.action.start-workflow', designerForm: true, listenerStatus: 'wired' },
    { actionType: 'audit-log-custom', eventName: 'automation.action.audit-log-custom', designerForm: true, listenerStatus: 'wired' },
    { actionType: 'apply-entity-update-draft', eventName: 'automation.action.apply-entity-update-draft', designerForm: true, listenerStatus: 'wired' },
    { actionType: 'sync-party-assignments', eventName: 'automation.action.sync-party-assignments', designerForm: true, listenerStatus: 'wired' },
    { actionType: 'ticket-transition', eventName: 'automation.action.ticket-transition', designerForm: true, listenerStatus: 'wired' },
    { actionType: 'ticket-assign', eventName: 'automation.action.ticket-assign', designerForm: true, listenerStatus: 'wired' },
    { actionType: 'integration.providerAction', eventName: 'automation.action.integration.providerAction', designerForm: true, listenerStatus: 'wired' },
];

/** NOTIFY node uses workflow.notify — not an ACTION type. */
export const WORKFLOW_NOTIFY_NODE_EVENT = 'workflow.notify';

export function getAutomationActionEntry(actionType) {
    return WORKFLOW_AUTOMATION_ACTION_REGISTRY.find((e) => e.actionType === actionType) || null;
}

export function listPendingAutomationActions() {
    return WORKFLOW_AUTOMATION_ACTION_REGISTRY.filter((e) => e.listenerStatus === 'pending');
}

export function isAutomationActionWired(actionType) {
    const e = getAutomationActionEntry(actionType);
    return e?.listenerStatus === 'wired';
}
